import { createTheme } from '@material-ui/core';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    common: {
      white: '#F4F4F4',
      black: '#000000',
      pink: '#CE0F65',
      blue: '#002855',
      gray: '#E0E0E0',
      red: '#d51332',
      green: '#4CAF50',
      darkGray: '#6F6F6F',
      pinkLigth: '#ce0f65c9',
      grayLight: '#2B5B90',
      blueLight: '#063365',
    },
    background: {
      default: '#FFFFFF',
      primary: '#002855',
      secondary: '#CE0F65',
      card: '#21456E',
      hoverCard: '#1e4879',
      score: 'rgba(60, 106, 158, 0.15)',
      info: '#FCD050',
      disabled: '#171717B2',
      steel: '#2B5B90',
      grey: '#8D8D8D',
      red: '#DC3C4F',
      green: '#4CAF50',
      buttonDisabled: '#A8A8A8',
      buttonQuizzDisabled: '#315175',
    },
    primary: {
      light: '#063365',
      main: '#002855',
      dark: '#002855',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#FFFFFF',
      main: '#CE0F65',
      contrastText: '#FFFFFF',
    },
    info: {
      light: '#FFFFFF',
      main: '#FCD050',
      contrastText: '#000000',
    },
    text: {
      default: '#FFFFFF',
      primary: '#000000',
      blue: '#21456E',
      secondary: '#161616',
      red: '#FF8855',
      alert: '#393939',
    },
    shadows: [
      'none',
      '0 10px 20px rgba(0,0,0,0.08), 0 4px 4px rgba(0,0,0,0.15);',
      '0 20px 30px rgb(0 0 0 / 20%), 0 6px 6px rgb(0 0 0 / 35%);',
    ],
    typography: {
      fontFamily: ['Raleway', 'Roboto'].join(','),
    },
  },
});

export default theme;
